angular.module('tf.controllers')

    .controller('ForgotPasswordController', function ($scope, AuthService, RecaptchaService) {


        $scope.disableButton = false;
        $scope.requireSSO = false;
        $scope.emailSent = false;
        $scope.credentials = {
            email: '',
            password: ''
        };

        $scope.resetEmail = function(credentials){
            $scope.disableButton = true;
            if($scope.requireSSO){
                window.location.href = '/sso?email=' + credentials.email;
                return;
            }
            RecaptchaService.execute().then(function(token){
                credentials['g-recaptcha-response'] = token;
                AuthService.redirectAfterLogin('null');
                AuthService.resetEmail(credentials).then(function(){
                    $scope.emailSent = true;
                }, function(){
                    $scope.disableButton = false;
                });
            },function(err){
                $scope.disableButton = false;
            });
        };

        try{
            RecaptchaService.renderV3('forgot-password-recaptcha');
        } catch (e) {

        }

    })
;
